/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useRef } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import useOutsideClick from '../../../../../../../../utils/click.utils';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { CheckListForm } from '../../../../../forms/CheckListForm';
import { ICheckListMenuProps } from './types';

export const CheckListMenu: FunctionComponent<ICheckListMenuProps> = ({ taskId }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskChecklist');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskChecklist'));
    }
  }, [dispatch, open]);
  const handleClickOutside = () => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    }
  };

  useOutsideClick({
    callback: handleClickOutside,
    refs: [popupRef, triggerRef],
    enabled: open,
  });
  return (
    <div className={taskId && open ? 'dropdown opened' : 'dropdown'}>
      <a
        className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 dropdown-button"
        title="Checklist"
        onClick={toggle}
        ref={triggerRef}
      >
        <i className="icon f-9 blueGray icon-check mr-1" /> Checklist
      </a>
      <div className="dropdown-menu drop-right">
        <div className="mini-popup" ref={popupRef}>
          <div className="mini-popup-header">
            Add checklist
            <span className="close_mini_popup" onClick={toggle}>
              ×
            </span>
          </div>
          <div className="mini-popup-body">
            <CheckListForm taskId={taskId} onClick={toggle} />
          </div>
        </div>
      </div>
    </div>
  );
};
